import { IDB_rowRead, IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsWrite, IDB_rowWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { Type_IFix } from '../Type/Type.hive'

export function IDB_fixRead(fixId: number) {
    return IDB_rowRead<Type_IFix>(IDB_globalDb, 'fixes', fixId)
}

export function IDB_fixesDelete(fixId: number[]) {
    return IDB_rowsDelete(IDB_globalDb, 'fixes', fixId)
}

export function IDB_fixesReadAll() {
    return IDB_rowsReadAll<Type_IFix>(IDB_globalDb, 'fixes')
}

export function IDB_fixesWrite(fixes: Type_IFix[]) {
    return IDB_rowsWrite(IDB_globalDb, 'fixes', fixes)
}

export function IDB_fixWrite(fix: Type_IFix) {
    return IDB_rowWrite(IDB_globalDb, 'fixes', fix)
}
